import React from "react";
import {
  Box,
  Typography,
  Divider,
  Paper,
  Button,
} from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PrintIcon from "@mui/icons-material/Print";
import { useEffect } from "react";

export default function CharacterCertificate({ receiptData, school, setTemID }) {
  const currentDate = new Date().toLocaleDateString("en-GB");
  const students = [{ ...receiptData?.data[0] }];

  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };
  const receiptId = `character`;

  useEffect(() => {
    if (setTemID) {
      setTemID(receiptId);
    }
  }, [receiptData, setTemID, receiptId]);

  return (
    <Box
      sx={{
        p: 3,
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#f3f6fc",
        minHeight: "40vh",
      }}
    >
      <Box id={receiptId}
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f3f6fc",
          minHeight: "40vh",
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: "750px", // A4 width
            minHeight: "400px", // A4 height 1123px
            p: 5,
            backgroundColor: "white",
            borderRadius: 2,
            position: "relative",
            fontFamily: "serif",
          }}
        >
          {/* Header */}
          <Box textAlign="center" mb={2}>
            {/* <VerifiedUserIcon color="success" sx={{ fontSize: 60 }} /> */}
            <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
              <img
                src={school.logoUrl} // replace with your logo path
                alt="School Logo"
                style={{ width: 80, height: 70, marginTop: 10 }}
              />

              <Typography variant="h6" align="center" fontWeight="bold">
                {toCamelCase(school.schoolName)}
              </Typography>
              <Typography variant="subtitle2" align="center">
                {toCamelCase([school?.addressDTO?.addressLine1, school?.addressDTO?.city, school?.addressDTO?.pincode, school?.addressDTO?.state].join(", "))}
              </Typography>

            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              textTransform="uppercase"
              color="success.main"
            >
              Character Certificate
            </Typography>
          </Box>

          {/* Body Content */}

          {students.map((student, i) => {

            return (
              <Typography
                key={i}
                variant="body1"
                sx={{ mt: 4, textAlign: "justify", lineHeight: 2, fontSize: "1.1rem" }}
              >
                This is to certify that{" "}
                <strong>{toCamelCase([student?.name, student?.last].filter(Boolean).join(" ")) || "____________"}</strong>, son/daughter of
                Mr./Ms. <strong>{toCamelCase([student?.father, student?.last].filter(Boolean).join(" ")) || "____________"}</strong> is/was
                a student of{" "}
                <strong>{toCamelCase(school.schoolName) || "____________"}</strong> during the
                year  <strong>{student?.classRoom?.academicYear || "__________"}</strong>.{" "}
                His/Her character and conduct were{" "}
                <strong>
                  {student?.charectar || "Good"}
                </strong>{" "}
                during his/her stay in this school.
              </Typography>
            );
          })}
          {/* Date */}
          <Typography sx={{ mt: 4, mb: 8, fontSize: "1.1rem" }}>
            Date: <strong>{currentDate}</strong>
          </Typography>

          {/* Signature Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 8,
              textAlign: "center",
            }}
          >
            <Box>
              <Typography variant="body1" sx={{ mb: 1 }}>
                ______________________
              </Typography>
              <Typography variant="subtitle2">(Class Teacher)</Typography>
            </Box>

            <Box>
              <Typography variant="body1" sx={{ mb: 1 }}>
                ______________________
              </Typography>
              <Typography variant="subtitle2">(Admission Incharge)</Typography>
            </Box>

            <Box>
              <Typography variant="body1" sx={{ mb: 1 }}>
                ______________________
              </Typography>
              <Typography variant="subtitle2">(Head Master)</Typography>
              <Typography variant="body2">(Seal)</Typography>
            </Box>
          </Box>

          {/* Print Button */}

        </Paper>
      </Box>
    </Box>
  );
}
